import FormControl from "common/components/FormControl/FormControl";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CrudForm from "common/components/Crud/CrudForm";
import type { EventType } from "types";
import ColorSelect from "components/select/ColorSelect/ColorSelect";

type Props = {
  onSubmit: (values: any) => any;
  onCancel?: () => void;
  item?: EventType;
};

function EventTypeForm({ onSubmit, onCancel, item }: Props) {
  const { t } = useTranslation();

  const initialValues = useMemo(
    () =>
      item?.id
        ? {
            ...item,
          }
        : {},
    [item]
  );

  return (
    <CrudForm
      onSubmit={onSubmit}
      onCancel={onCancel}
      initialValues={initialValues}
      headerIcon="CalendarDaysIcon"
      i18nNamespace="event-types"
      render={() => (
        <div className="white-box flex flex-col gap-2">
          <FormControl name="name" title={t("event-types.name")} required />
          <FormControl
            name="color"
            type="custom"
            isSelect
            title={t("event-types.color")}
          >
            <ColorSelect />
          </FormControl>
        </div>
      )}
    />
  );
}

export default EventTypeForm;
